export interface IReportLine {
    codAge: number;
    investigationDuration: number;
    managerReviewDuration?: number;
    financeReviewDuration?: number;
    creditReviewDuration?: number;
    codNumber: string;
    codOriginator: string;
    codOriginatorEmail: string;
    region: string;
    natureOfComplaint: string;
    issueType: string;
    referenceNumberType: string;
    referenceNumber: string;
    salesOrderLine: number;
    affectedQty: number;
    investigatorConfirmedNatureOfComplaint: string;
    investigatorConfirmedIssueType: string;
    investigationFailureRootCause: string;
    investigationCsrFailure: string;
    investigationCsrFailureEmail: string;
    investigationFailureLocation: string;
    codStatus: string;
    currentAssignee: string;
    assignedOn: string;
    codCreationDate: string;
    codClosureDate?: string;
    investigationAssignee: string;
    investigationAssigneeEmail: string;
    investigationAssignmentDate: string;
    investigationCompletionDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    creditReviewAssignee: string;
    creditReviewAssigneeEmail: string;
    creditReviewAssignmentDate: string;
    creditReviewCompletionDate: string;
    managerReviewAssignee: string;
    managerReviewAssigneeEmail: string;
    managerReviewAssignmentDate: string;
    managerReviewCompletionDate: string;
    financeReviewAssignee: string;
    financeReviewAssigneeEmail: string;
    financeReviewAssignmentDate: string;
    financeReviewCompletionDate: string;
    pgiDate: string;
    transportUnit: string;
    shipToCustomerNumber: string;
    shipToCustomerName: string;
    salesOrderNumber: string;
    purchaseOrderReference: string;
    invoiceNumber: string;
    salesOrganisation: string;
    route: string;
    creditAdjustmentAmount: number;
    deliveredQuantity: number;
    sapDeliveryNumber: string;
    materialDescription: string;
    smn: string;
    orderedQuantity: number;
    sourcePlant: string;
    sourceCountry: string;
    shipToCountry: string;
    shipmentNumber: string;
    carrierTrackingNumber: string;
    affectedValue: number;
    handlingUnit: string;
    soCreationDate: string;
    additionalCustomerDetails: string;
    investigationSummary: string;
}
